// PolymorphicField: Utility for schema field logic (universal)
export default class PolymorphicField {
  // Returns the effective label: custom label or prettified name
  static getLabel(field) {
    if (field.label) return field.label;
    // Prettify: capitalize, replace underscores
    return field.name.charAt(0).toUpperCase() + field.name.slice(1).replace(/_/g, ' ');
  }

  // Returns the effective type: default to 'text' if not specified
  static getType(field) {
    return field.type || 'text';
  }

  // Returns the description, or undefined
  static getDescription(field) {
    return field.description;
  }

  // Returns the effective placeholder (label by default)
  static getPlaceholder(field) {
    return this.getLabel(field);
  }

  // Precompute all field properties for an array of fields
  static compute(fields) {
    return fields.map((field) => ({
      ...field,
      label: field.label || this.getLabel(field),
      type: field.type || 'text',
      description: field.description,
      placeholder: field.placeholder || this.getLabel(field)
    }));
  }

  // Precompute the entire schema (all entity fields)
  static computeSchema(schema) {
    const computed = {};
    for (const [entity, def] of Object.entries(schema)) {
      computed[entity] = { ...def };
      if (def.fields) {
        computed[entity].fields = this.compute(def.fields);
      }
      if (def.relations) {
        computed[entity].relations = def.relations.map((r) => ({ ...r }));
      }
    }
    return computed;
  }
}
